
/**
 * Finds the nearest value in an array to the target within a given tolerance.
 *
 * @param {Array<number>} arr - The array of numbers to search through.
 * @param {number} target - The target number to find the nearest value to.
 * @param {number} tolerance - The tolerance as a fraction (0 to 1) of the target.
 * @returns {number} - The nearest value within the tolerance, or the target if no value is found.
 */
export function findNearestWithinTolerance(arr, target, tolerance) {
  const threshold = tolerance * target;
  let nearestValue = null;
  let nearestDistance = Infinity;

  for (const value of arr) {
    const distance = Math.abs(value - target);

    if (distance <= threshold && distance < nearestDistance) {
      nearestValue = value;
      nearestDistance = distance;
    }
  }

  return nearestValue !== null ? nearestValue : target;
}

/**
 * Finds the nearest value in an array for the given target.
 * @param {Array<number>} arr - The array of numbers to search through.
 * @param {number} target - The target number to find the nearest value to.
 * @returns {number} - The nearest value
 */
export function findNearest(arr, target) {
  return arr.reduce((prev, curr) =>
    Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev
  );
}
